"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDocumentHash = void 0;
const getDocumentHash = () => {
    const tag = document.querySelector("meta[name='ui-version']");
    if (tag) {
        return tag.content || '';
    }
    return '';
};
exports.getDocumentHash = getDocumentHash;
//# sourceMappingURL=getDocumentHash.js.map